export const getCurrentMockAccount = () => JSON.parse(window.sessionStorage.getItem('mock-account') || '""');
